import morphdom from 'morphdom';

window.App = window.App || { mutation_observers: [] };

const autoloadCache = {};

export const autoLoad = (scope) => {
  const $auto = $('.js-auto-load', scope);
  const empty = $auto.data('empty');

  if (empty === true || $auto.data('autoLoad')) { return; }

  $auto.data('autoLoad', 'loading');

  $auto.each(function onEach() {
    const { url } = this.dataset;

    autoloadCache[url] && (this.innerHTML = autoloadCache[url]);

    $.ajax({
      url,
      context: this,
      headers: {
        'X-No-Layout': 1,
      },
    }).done((resp) => {
      if (autoloadCache[url] !== resp) {
        this.innerHTML = resp;
        autoloadCache[url] = resp;
      }
      $(this).trigger('autoLoad:success').data('autoLoad', 'done');
    });
  });
};

document.addEventListener('turbolinks:load', () => {
  autoLoad();
});

App.mutation_observers.push(autoLoad);

export const reloadElement = (selector) => {
  const element = document.querySelector(selector);
  if (!element) { return; }

  const { pathname, search } = window.location;
  let newSearch;

  if (!search) {
    newSearch = `${search}?x-partial-selector=${selector}`;
  } else {
    newSearch = `${search}&x-partial-selector=${selector}`;
  }

  const url = pathname + newSearch;

  $.ajax({
    url,
    headers: {
      'X-Inline-Form': 1,
      'X-Partial-Selector': selector,
    },
  }).done((response) => {
    morphdom(element, response);
  });
};

window.reloadElement = reloadElement;

export const $d = (selector, id) => $(`${selector}[data-id="${id}"]`);
